/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

import { ClipLoader } from 'react-spinners';

import { useTheme } from 'styled-components';
import { Backdrop } from '@mui/material';

import { IFCWithChildren } from '../interfaces/i-fc-with-children';

interface IBackdropContextProps {
  readonly active: boolean;
  readonly enableBackdrop: () => void;
  readonly disableBackdrop: () => void;
}

const BackdropContext = createContext<IBackdropContextProps>(
  {} as IBackdropContextProps
);

interface IBackdropProviderProps {
  readonly startsOpen?: boolean;
}

const BackdropProvider: IFCWithChildren<IBackdropProviderProps> = ({
  children,
  startsOpen = false,
}) => {
  const theme = useTheme();
  const [active, setActive] = useState<boolean>(startsOpen);

  const enableBackdrop = useCallback(() => {
    setActive(true);
  }, []);

  const disableBackdrop = useCallback(() => {
    setActive(false);
  }, []);

  const contextData = useMemo(
    () => ({
      active,
      enableBackdrop,
      disableBackdrop,
    }),
    [active, enableBackdrop, disableBackdrop]
  );

  return (
    <BackdropContext.Provider value={contextData}>
      {active && (
        <Backdrop sx={{ color: '#fff', zIndex: 500 }} open>
          <ClipLoader color={theme.neutral[0]} loading size={36} />
        </Backdrop>
      )}
      {children}
    </BackdropContext.Provider>
  );
};

const useBackdrop = (): IBackdropContextProps => useContext(BackdropContext);

export { useBackdrop, BackdropProvider };
